import {
  DashboardFilter,
  ParsedDashboardFilterOptions
} from 'types/GlobalDashboardFilter'
import type { TSavedDashboardFilterConditionDto } from '@homepal/api-contract'

export const formatPutConditions = (
  dashboardFilter: DashboardFilter,
  dashboardFilterOptions: Map<string, ParsedDashboardFilterOptions>
) => {
  return Object.values(
    dashboardFilter.reduce<Record<string, TSavedDashboardFilterConditionDto>>(
      (acc, item) => {
        const option = dashboardFilterOptions.get(item.attribute)

        if (!option) {
          // only process filters from dashboard filters,
          // will exclude onclick filters not present.
          return acc
        }

        if (!acc[item.attribute]) {
          acc[item.attribute] = {
            attribute_id: item.attribute,
            values: []
          }
        }
        acc[item.attribute].values.push(
          typeof item.value === 'number' ? String(item.value) : item.value
        )

        return acc
      },
      {}
    )
  )
}
